"use strict";

exports.__esModule = true;
exports.default = void 0;

var choose = function (options) {
  if (options === void 0) {
    options = {};
  }

  return new Promise(function (resolve, reject) {
    var _options = options,
        _options$count = _options.count,
        count = _options$count === void 0 ? 1 : _options$count,
        _options$sourceType = _options.sourceType,
        sourceType = _options$sourceType === void 0 ? ['camera', 'album'] : _options$sourceType,
        sizeType = _options.sizeType;
    tt.chooseImage({
      sourceType: sourceType,
      count: count,
      sizeType: sizeType,
      success: function success(res) {
        resolve(Object.assign({}, {
          data: res.tempFilePaths
        }, res));
      },
      fail: function fail(e) {
        reject(e);
      }
    });
  });
};

var _default = choose;
exports.default = _default;